<script>
export default {
  props: {
    removable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<template>
  <div :class="$style.tagSelectorContainer">
    <slot />
    <span v-if="removable">
      <i
        @click="
          () => {
            this.$emit('remove')
          }
        "></i>
    </span>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.tagSelectorContainer {
  position: relative;
  width: fit-content;
  padding: 8px 10px 8px 10px;
  font-size: 14px;
  color: white;
  white-space: nowrap;
  background-color: $primary-blue;
  border-radius: 22px;
  outline: none;
  appearance: none;

  span {
    display: inline-block;
    width: 10px;
  }

  i {
    position: absolute;
    top: 50%;
    right: 0;
    bottom: 0;
    width: 22px;
    height: 22px;
    margin-left: 7px;
    font-style: normal;
    font-weight: 700;
    text-align: center;
    cursor: pointer;
    transform: translate(0, -50%);

    &::after {
      font-size: 14px;
      color: $white;
      content: '\D7';
    }
  }
}

.closeButton {
  svg {
    width: 15px;
  }

  cursor: pointer;
}
</style>
